<!-- layouts/AppFooter.vue -->
<template>
    <footer class="footer">
      <div class="container">
        <p>&copy; 2025 Medicko. All rights reserved.</p>
      </div>
    </footer>
  </template>
  
  <style scoped>
  .footer {
    background: #333;
    color: white;
    text-align: center;
    padding: 2rem 0;
  }
  
  .container {
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 20px;
  }
  </style>